



// 



import { Component } from '@angular/core';
import { fadeInOut } from '../../../services/animations';
import { ApiService } from '../../../services/api.service';
import { MatDialog } from '@angular/material';
import { AlertService, DialogType } from '../../../services/alert.service';
import { CreateEditQuoteTemplateModalComponent } from './create-edit-quote-template-modal/create-edit-quote-template-modal.component';
import { Router } from '@angular/router';
import { Service } from '../../../models/service.model';
import { QuoteTemplate } from '../../../models/quote-template.model';

@Component({
    selector: 'quote-templates',
    template: require('./quote-templates.component.html'),
    styles: [require('./quote-templates.component.css')],
    animations: [fadeInOut]
})
export class QuoteTemplatesComponent {
    quoteTemplates: QuoteTemplate[];
    constructor(private router: Router, private apiService: ApiService, public dialog: MatDialog, private alertService: AlertService) {
        this.getQuoteTemplates();
    }

    getQuoteTemplates() {
        this.apiService.getQuoteTemplates().subscribe(r => {
            this.quoteTemplates = r;
        })
    }

    createEditQuoteTemplate(quoteTemplate: any) {
        let dialogRef = this.dialog.open(CreateEditQuoteTemplateModalComponent, {
            width: '600px',
            data: {
                currentQuoteTemplate: quoteTemplate || {},
                //vendors: this.QuoteTemplates
            }
        });

        dialogRef.afterClosed().subscribe(r => {
            this.getQuoteTemplates();
        })
    }

    deleteQuoteTemplate(quoteTemplateId: number) {
        this.alertService.showDialog("Do you want to delete this quoteTemplate ?", DialogType.confirm, val => {

            this.apiService.deleteQuoteTemplate(quoteTemplateId).subscribe(r => {
                this.getQuoteTemplates();
            });
        });
    }

    onActivate(event) {
        if (event.type === 'click') {
            this.router.navigate(['/quoteTemplates/' + event.row.quoteTemplateId]);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/quote-settings/quote-templates/quote-templates.component.ts